var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "md-mermaid" }, [
    _vm.error
      ? _c("div", { staticClass: "md-mermaid-error" }, [
          _c("i", { staticClass: "fas fa-exclamation-triangle" }),
          _vm._v(" " + _vm._s(_vm.error) + "\n    "),
        ])
      : _c("div", { ref: "container", staticClass: "md-mermaid-canvas" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }